export default {"src":"/_next/static/media/stamp-placeholder.02aaf304.svg","height":33,"width":38,"blurWidth":0,"blurHeight":0};